import { SEARCH_PARAMETERS_SCHEMA } from './schema';
import { SearchParameterSerializer } from './serialization';
import type { SearchParameters } from './searchParameters';

export class SearchQueryFactory {
  readonly #serializer: SearchParameterSerializer;

  constructor(
    serializer = new SearchParameterSerializer(SEARCH_PARAMETERS_SCHEMA)
  ) {
    this.#serializer = serializer;
  }

  fromSearchParameters = (sp: SearchParameters): Record<string, string> =>
    this.#serializer.serialize(sp.toJSON());
}
